import { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import apiService from "../../service/apiService";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import UploadIcon from '@mui/icons-material/Upload';
import { Download } from "@mui/icons-material";
import { debounce } from "lodash";

const Farmerdata = () => {
  const navigate = useNavigate();
  
  // Essential state variables only
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [farmername, setFarmerName] = useState("");
  const [age, setAge] = useState("");
  const [fathername, setFatherName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [classoffarmer, setClassoffarmer] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [gramPanchayat, setGramPanchyat] = useState("");
  const [village, setVillage] = useState("");
  const [pgname, setPGname] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mip, setMip] = useState("");
  const [koId, setKoId] = useState("");
  const [availableLand, setAvailableLand] = useState(null);
  const [farmerid, setFarmerId] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [castes, setCastes] = useState([]);
  const [farmerClasses, setFarmerClasses] = useState([]);
  const [producerGroups, setProducerGroups] = useState([]);
  const [genders, setGenders] = useState([]);
  const [farmerClassifications, setFarmerClassifications] = useState([]);
  
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
  const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
  
  const [formData, setFormData] = useState({
    age: '',
    fatherName: '',
    caste: '',
    phoneNumber: '',
    farmerName: '',
    aadhaarNumber: '',
    gender: '',
    farmerClassification: '',
    producerGroups: '',
    registeredDate: '',
    availableLand: ''
  });

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  // Essential useEffects
  useEffect(() => {
    const requiredFields = [
      "farmerName", "fatherName", "age", "gender", "caste", "producerGroups",
      "phoneNumber", "registeredDate", "aadhaarNumber", "availableLand", "farmerClassification"
    ];
    const isAnyFieldEmpty = requiredFields.some(
      (field) => !formData[field] || formData[field] === 0 || formData[field] === ""
    );
    setIsSaveDisabled(isAnyFieldEmpty);
  }, [formData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [casteRes, farmerClassRes, producerGroupRes, genderRes] = await Promise.all([
          apiService.get("/castes/get-all"),
          apiService.get("/farmer-classifications/get-all"),
          apiService.get("/producer-groups/get-all"),
          apiService.get("/master/get-all-gender")
        ]);

        setCastes(casteRes.data.map(item => ({ casteId: item.casteId, caste: item.caste })));
        setFarmerClasses(farmerClassRes.data);
        setFarmerClassifications(farmerClassRes.data.map(item => ({ 
          farmerClassId: item.farmerClassId, 
          farmerClass: item.farmerClass 
        })));
        setProducerGroups(producerGroupRes.data.map(item => ({ 
          producerGroupId: item.producerGroupId, 
          pgname: item.pgname 
        })));
        setGenders(genderRes.data.map(item => ({ 
          genderId: item.genderId, 
          gender: item.gender 
        })));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      const currentDist = loginData?.districtId ? loginData.districtId : 0;
      if (currentDist) {
        const defDist = response.data.find((dis) => dis.districtId === currentDist);
        setDistrict(defDist ? defDist.districtName : "");
      }
    } catch (error) {
      setDistrict("");
      console.error('Error fetching districts:', error);
    }
  };

  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      const currentBlock = loginData?.blockId ? loginData.blockId : 0;
      if (currentBlock) {
        const defBlock = response.data.body.blocks.find((blk) => blk.blockId === currentBlock);
        setBlock(defBlock ? defBlock.blockName : "");
      }
    } catch (error) {
      setBlock("");
      console.error("Error fetching blocks:", error);
    }
  }

  useEffect(() => {
    fetchAllDist();
  }, []);

  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  const fetchData = async () => {
    try {
      const response = await apiService.post("/farmers/get-all-farmer-index-data", {
        villageId: 0,
        mipId: 0,
        blockId: 0,
        districtId: 0,
        farmerId: 0,
        producerGroupId: 0,
        pageNumber: page,
        pageSize: pageSize,
        farmerName: farmername,
        age: age || null,
        gender: gender,
        caste: caste,
        fatherName: fathername,
        classOfFarmers: classoffarmer,
        district: district,
        block: block,
        gramPanchayat: gramPanchayat,
        village: village,
        mipName: mip,
        pgName: pgname,
        aadharNumber: aadharNumber,
        mobileNumber: mobileNumber,
        availableLand: availableLand,
        koId: koId
      });

      if (response.data.status && response.data.body && response.data.body.data) {
        const data = response.data.body.data;
        const formattedData = data.map((item) => ({
          id: item.farmerId,
          farmerId: item.farmerId,
          farmerName: item.farmerName,
          age: item.age,
          fatherName: item.fatherName || "Not Available",
          phoneNumber: item.phoneNumber,
          gender: item.gender,
          caste: item.caste,
          gpName: item.gpName,
          villageName: item.villageName || "Not Available",
          pgName: item.pgName || "Not Available",
          mipName: item.mipName || "Not Available",
          districtName: item.districtName,
          blockName: item.blockName,
          aadharNumber: item.aadharNumber || "Not Available",
          classOfFarmer: item.farmerClass || "Not Available",
          availableLand: item.availableLand || "0",
          remainingLand: item.remainingLand || "0",
          totalPlainLand: item.totalPlainLand || "0",
          koId: item.koId || "NA",
        }));
        setRows(formattedData);
        setTotalitems(response.data.body.recordsCount);
        setTotalpage(response.data.body.pageCount);
      } else {
        setRows([]);
        setTotalitems(0);
        setTotalpage(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRows([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    page, pageSize, farmername, age, fathername, gender, caste, classoffarmer,
    district, block, gramPanchayat, village, pgname, aadharNumber, mobileNumber, mip, availableLand, koId
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const handleEdit = async (farmerId) => {
    try {
      setFarmerId(farmerId);
      const response = await apiService.get(`/farmers/${farmerId}`);
      if (response.status === 200) {
        const data = response.data;
        setFormData({
          age: data.age || "",
          fatherName: data.fatherName || "Not Available",
          caste: data.casteId || "Not Available",
          phoneNumber: data.phoneNumber || "",
          farmerName: data.farmerName || "",
          aadhaarNumber: data.aadhaarNumber || "Not Available",
          gender: data.genderId || "Not Available",
          farmerClassification: data.farmerClassId || "Not Available",
          producerGroups: data.producerGroupId || "Not Available",
          registeredDate: data.registeredDate || "",
          availableLand: data.availableLand || 0
        });
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching farmer details:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedRow(null);
  };

  const handleDelete = (id) => {
    setSelectedRow(rows.find((row) => row.id === id));
    setOpenDelete(true);
  };

  const handleDeleteRow = async () => {
    try {
      const { id: farmerId } = selectedRow;
      await apiService.delete(`/farmers/delete/${farmerId}`);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      handleCloseDelete();
    }
  };

  const handleSaveEdit = async () => {
    const isConfirmed = window.confirm("Are you sure you want to update this Farmer info?");
    if (!isConfirmed) return;

    try {
      const {
        farmerName, fatherName, age, phoneNumber, gender, caste, producerGroups,
        farmerClassification, registeredDate, aadhaarNumber, availableLand
      } = formData;

      const dateObj = new Date(registeredDate);
      const formattedRegisteredDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;

      const payload = {
        farmerName,
        fatherName,
        age: parseInt(age, 10),
        phoneNumber,
        genderId: parseInt(gender, 10),
        casteId: parseInt(caste, 10),
        producerGroupId: parseInt(producerGroups, 10),
        farmerClassId: parseInt(farmerClassification, 10),
        registeredDate: formattedRegisteredDate,
        aadharNumber: aadhaarNumber,
        availableLand: parseFloat(availableLand)
      };

      await apiService.put(`/farmers/update/${farmerid}`, payload);
      handleClose();
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert("Please select a file.");
      return;
    }

    const confirmUpload = window.confirm("Are you sure you want to upload this file?");
    if (!confirmUpload) return;

    const formData = new FormData();
    formData.append('file', file);

    apiService.post('/upload/farmer-upload', formData, {
      headers: {
        'accept': '*/*',
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        alert("File uploaded successfully!");
        fetchData();
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        alert("Failed to upload file. Please try again.");
      });
  };

  const handleDownloadExcel = () => {
    const headers = [
      "SlNo", "FarmerName", "Age", "Gender", "Caste", "PGCode", "FarmerClass",
      "FatherName", "AadhaarNumber", "MobileNo", "AvailableLand", "KOId"
    ];
    const worksheetData = [headers];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "sheet1");
    XLSX.writeFile(workbook, "Farmer_management_format.xlsx");
  };

  const exportToExcel = async () => {
    try {
      const response = await apiService.post("/farmers/get-all-farmer-index-data", {
        villageId: 0, mipId: 0, blockId: 0, districtId: 0, farmerId: 0, producerGroupId: 0,
        pageNumber: 1, pageSize: totalItems,
        farmerName: farmername || "", age: age || null, gender: gender || "",
        caste: caste || "", fatherName: fathername || "", classOfFarmers: classoffarmer || "",
        district: district || "", block: block || "", gramPanchayat: gramPanchayat || "",
        village: village || "", mipName: mip || "", pgName: pgname || "",
        aadharNumber: aadharNumber || "", mobileNumber: mobileNumber || "",
        availableLand: availableLand || null, koId: koId || ""
      });

      if (response.data.status && response.data.body && response.data.body.data) {
        const data = response.data.body.data;
        const headers = [
          "Sl No", "Farmer Name", "Age", "Gender", "Caste", "Father's Name", "Class",
          "District", "Block", "Gp", "Village", "MIP", "PG", "Aadhar", "KOID",
          "Phone Number", "Agri. Land (ha)","Planned Agri. Land (ha)", "Remaining Agri. Land (ha)"
        ];

        const dataToExport = data.map((item, index) => [
          index + 1, item.farmerName || "", item.age || "", item.gender || "",
          item.caste || "", item.fatherName || "Not Available",
          item.farmerClass || "Not Available", item.districtName || "",
          item.blockName || "", item.gpName || "", item.villageName || "Not Available",
          item.mipName || "Not Available", item.pgName || "Not Available",
          item.aadharNumber || "Not Available", item.koId || "NA",
          item.phoneNumber || "", item.availableLand || 0, item.totalPlainLand || 0, item.remainingLand || 0
        ]);

        const sheetData = [headers, ...dataToExport];
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Farmer_management_data.xlsx");
      }
    } catch (error) {
      console.error("Error fetching and exporting data:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  return (
    <Box style={{
      backgroundColor: "#f8f9fa",
      overflowY: "auto"
    }}>
      {/* Header - Same design as ffd.jsx */}
      <div style={{
        backgroundColor: "#ffffff",
        borderBottom: "3px solid #007bff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center py-3 px-4">
            <div className="d-flex align-items-center">
              <div>
                <h1 style={{
                  fontSize: "1.8rem",
                  fontWeight: "600",
                  color: "#2c3e50",
                  margin: "0"
                }}>
                  Farmer Management
                </h1>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="contained"
                onClick={() => navigate("/addFarmer")}
                style={{
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                + Add New
              </Button>
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadIcon />}
                style={{
                  backgroundColor: "#6c757d",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Upload Excel
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleFileUpload}
                />
              </Button>
              <Button
                variant="contained"
                onClick={handleDownloadExcel}
                style={{
                  backgroundColor: "#17a2b8",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Download Format
              </Button>
              <Button
                variant="contained"
                startIcon={<Download />}
                onClick={exportToExcel}
                style={{
                  backgroundColor: "#007bff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Export Excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Same design as ffd.jsx */}
      <div className="container-fluid" style={{ padding: "20px" }}>
        <div style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 160px)"
        }}>
          <div style={{
            flex: "1",
            overflowY: "auto",
            overflowX: "auto"
          }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0" style={{
                minWidth: "2000px",
                backgroundColor: "#fff"
              }}>
                <thead style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  position: "sticky",
                  top: "0",
                  zIndex: "10"
                }}>
                  <tr>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "60px"
                    }}>
                      SL
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={farmername}
                        onChange={(e) => { setFarmerName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "70px"
                    }}>
                      Age
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={age}
                        onChange={(e) => { setAge(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "70px"
                    }}>
                      Gender
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={gender}
                        onChange={(e) => { setGender(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        {genders.map((item) => (
                          <option key={item.genderId} value={item.gender}>
                            {item.gender}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "70px"
                    }}>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={caste}
                        onChange={(e) => { setCaste(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((item) => (
                          <option key={item.casteId} value={item.caste}>
                            {item.caste}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Father's Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={fathername}
                        onChange={(e) => { setFatherName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Farmer Classification
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={classoffarmer}
                        onChange={(e) => { setClassoffarmer(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        {farmerClasses.map((farmerClass) => (
                          <option key={farmerClass.farmerClassId} value={farmerClass.farmerClass}>
                            {farmerClass.farmerClass}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={district}
                        onChange={(e) => {
                          if (dist === 0) {
                            setDistrict(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={dist > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={block}
                        onChange={(e) => {
                          if (blk === 0) {
                            setBlock(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={blk > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={gramPanchayat}
                        onChange={(e) => { setGramPanchyat(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={village}
                        onChange={(e) => { setVillage(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={mip}
                        onChange={(e) => { setMip(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      PG
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={pgname}
                        onChange={(e) => { setPGname(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Aadhar
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={aadharNumber}
                        onChange={(e) => { setAadharNumber(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      KO ID
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={koId}
                        onChange={(e) => { setKoId(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Mobile No.
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={mobileNumber}
                        onChange={(e) => { setMobileNumber(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Agri. Land (ha)
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={availableLand}
                        onChange={(e) => {
                          const value = e.target.value.trim();
                          setAvailableLand(value === "" ? null : value);
                          setPage(1);
                        }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Planned Agri. Land (ha)
                      <br />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Remaining Agri. Land (ha)
                      <br />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      minWidth: "120px"
                    }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {rows.map((data, index) => (
                    <tr key={index} style={{
                      backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                      borderBottom: "1px solid #dee2e6"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e3f2fd";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                      }}>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {(page - 1) * 10 + index + 1}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.farmerName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.age}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: data.gender === 'Male' ? '#d4edda' : data.gender === 'Female' ? '#f8d7da' : '#fff3cd',
                          color: data.gender === 'Male' ? '#155724' : data.gender === 'Female' ? '#721c24' : '#856404',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500"
                        }}>
                          {data.gender}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.caste}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.fatherName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.classOfFarmer}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.districtName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.blockName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.gpName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.villageName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.mipName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.pgName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.aadharNumber}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.koId}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.phoneNumber}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "600"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.availableLand}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "600"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.totalPlainLand}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "600"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.remainingLand}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center"
                      }}>
                        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleEdit(data.id)}
                            title="Edit"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaRegEdit />
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(data.id)}
                            title="Delete"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pagination - Same design as ffd.jsx */}
        <div className='d-flex justify-content-between align-items-center py-3 px-3' style={{
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #dee2e6"
        }}>
          <div>
            <span style={{
              color: "#6c757d",
              fontSize: "14px"
            }}>
              Showing <strong>{(page - 1) * 10 + 1}</strong> to <strong>{Math.min(page * 10, totalItems)}</strong> of <strong>{totalItems}</strong> entries
            </span>
          </div>
          <div>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

      {/* Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Edit Farmer Info</DialogTitle>
        <DialogContent>
          <TextField
            name="farmerName"
            label={<>Farmer Name <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.farmerName || ""}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="age"
            label={<>Age <span style={{ color: "red" }}>*</span></>}
            type="number"
            fullWidth
            value={formData.age || ""}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="fatherName"
            label={<>Father's Name <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.fatherName || ""}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="phoneNumber"
            label={<>Phone Number <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.phoneNumber || ""}
            onChange={handleChange}
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="gender-label">Gender <span style={{ color: "red" }}>*</span></InputLabel>
            <Select
              labelId="gender-label"
              name="gender"
              value={formData.gender || ""}
              onChange={handleChange}
              label={<>Gender <span style={{ color: "red" }}>*</span></>}
            >
              {genders.map((gender) => (
                <MenuItem key={gender.genderId} value={gender.genderId}>
                  {gender.gender}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel id="caste-label">Caste <span style={{ color: "red" }}>*</span></InputLabel>
            <Select
              labelId="caste-label"
              name="caste"
              value={formData.caste || ""}
              onChange={handleChange}
              label={<>Caste <span style={{ color: "red" }}>*</span></>}
            >
              {castes.map((caste) => (
                <MenuItem key={caste.casteId} value={caste.casteId}>
                  {caste.caste}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            name="aadhaarNumber"
            label={<>Aadhaar Number <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.aadhaarNumber || ""}
            onChange={handleChange}
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="farmer-classification-label">Farmer Classification <span style={{ color: "red" }}>*</span></InputLabel>
            <Select
              labelId="farmer-classification-label"
              name="farmerClassification"
              value={formData.farmerClassification || ""}
              onChange={handleChange}
              label={<>Farmer Classification <span style={{ color: "red" }}>*</span></>}
            >
              {farmerClassifications.map((classification) => (
                <MenuItem key={classification.farmerClassId} value={classification.farmerClassId}>
                  {classification.farmerClass}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel id="producer-groups-label">Producer Groups <span style={{ color: "red" }}>*</span></InputLabel>
            <Select
              labelId="producer-groups-label"
              name="producerGroups"
              value={formData.producerGroups || ""}
              onChange={handleChange}
              label={<>Producer Groups <span style={{ color: "red" }}>*</span></>}
            >
              {producerGroups.map((group) => (
                <MenuItem key={group.producerGroupId} value={group.producerGroupId}>
                  {group.pgname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            name="registeredDate"
            type="date"
            fullWidth
            value={formData.registeredDate || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="dense"
            label={<>Registered Date <span style={{ color: "red" }}>*</span></>}
          />
          <TextField
            name="availableLand"
            label={<>Available Land(ha) <span style={{ color: "red" }}>*</span></>}
            type="number"
            fullWidth
            value={formData.availableLand || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSaveEdit} disabled={isSaveDisabled} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Farmer?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">Cancel</Button>
          <Button onClick={handleDeleteRow} color="primary">Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Farmerdata;
